<button
    *transloco="let t"
    (click)="openSearch()"
    class="d-flex h-8 w-8 rounded-lg text-primaryDark items-center justify-content-center hover:bg-white"
>
    <!--Todo: // [desing-ref] icon-->
    <mat-icon> search</mat-icon>
</button>
